// extracted by mini-css-extract-plugin
export default {"wrapper":"InvestmentPlan_wrapper__W6eSR"};